module.exports = __webpack_public_path__ + "img/check-square.d8cedded.svg";